import * as React from 'react';
import { css } from 'glamor';
import TimerView from './TimerView'
import MicRecorder from 'mic-recorder-to-mp3'

// const recorder = new MicRecorder({
//     bitRate: 128,
//     encoder: 'mp3', // default is mp3, can be wav as well
//     sampleRate: 44100, // default is 44100, it can also be set to 16000 and 8000.
// });

const buttonControls = css({
    "width": "3em",
    "height": "3em",
    "borderRadius": "50%",
    "alignItems": "center",
    "justifyContent": "center",
    "border": 0,
    "transition": "all .2s ease-out",
    "margin": "0.4em",
    "cursor": "pointer",
})
interface FileAudio {
    name: string
    type: string,
    size: number,
    lastModified: number
    uri: string
    webkitRelativePath?: string
}
export interface IAudioRecorderProps {
    onFileAvailable?(file: any): Promise<void>
    onUriAvailable?(uri: string): void
}

const AudioRecorder: React.FC<IAudioRecorderProps> = (props) => {
    const [link, setLink] = React.useState(null)
    const [startingRecording, setStartingRecording] = React.useState(false);
    const [showTimer, setShowTimer] = React.useState(false)
    const timerRef = React.useRef(null)
    const recorderRef = React.useRef(null);
    React.useEffect(() => {

        recorderRef.current = new MicRecorder({
            bitRate: 128,
            encoder: 'mp3', // default is mp3, can be wav as well
            sampleRate: 44100, // default is 44100, it can also be set to 16000 and 8000.
        });

        return () => {

        }
    }, [])
    const startRecording = () => {
        restTimer()
        setLink(null)
        setShowTimer(true)
        startTimer()

        recorderRef.current.start().then((res) => {
            console.log("res", res)
            setStartingRecording(true)


            // something else
        }).catch((e) => {
            console.error(e)
        });
    }


    const stopRecording = () => {

        recorderRef.current
            .stop()
            .getMp3().then(([buffer, blob]) => {

                stopTimer()
                setStartingRecording(false)
                setShowTimer(false)
                // do what ever you want with buffer and blob
                // Example: Create a mp3 file and play
                const lastModified = Date.now()
                // new Date().toISOString() 
                const file = new File(buffer, `audio-recored-${lastModified}.mp3`, {
                    type: blob.type,
                    lastModified: lastModified,

                });

                const linkUrl = window.URL.createObjectURL(file)
                setLink(linkUrl)

                if (props.onUriAvailable) {
                    props.onUriAvailable(linkUrl)

                }
                if (props.onFileAvailable) {
                    props.onFileAvailable(file)
                }
                // const player = new Audio(URL.createObjectURL(file));
                // player.play();

            }).catch((e) => {
                setShowTimer(false)
                stopTimer()
                setStartingRecording(false)
                console.log(e);
            });

    }
    const startTimer = () => {
        if (timerRef.current) {
            timerRef.current.start()
        }
    }

    /**
     * 
     */
    const stopTimer = () => {
        if (timerRef.current) {
            timerRef.current.stop()
        }
    }
    const restTimer = () => {
        if (timerRef.current) {
            timerRef.current.rest()
        }
    }
    const hiddenTimer = () => {
        if (timerRef.current) {
            timerRef.current.hidden()
        }
    }
    const showTimere = () => {
        if (timerRef.current) {
            timerRef.current.show()
        }
    }

    const blobToBase64 = async (blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
        });
    };


    return (
        <div>
            <TimerView ref={timerRef} show={showTimer} />
            {!startingRecording && <button onClick={startRecording} className={`btn btn-danger ${buttonControls}`} type="button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" className="svg">

                    <path className="off" d="M24 28c3.31 0 5.98-2.69 5.98-6L30 10c0-3.32-2.68-6-6-6-3.31 0-6 2.68-6 6v12c0 3.31 2.69 6 6 6zm10.6-6c0 6-5.07 10.2-10.6 10.2-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c6.56-.97 12-6.61 12-13.44h-3.4z" fill="white"></path>
                </svg></button>}
            {startingRecording && <button onClick={stopRecording} className={`btn btn-success ${buttonControls}`} type="button"><i className="fa fa-pause" /></button>}
            {/* <div>
                {link && <audio controls >
                    <source type="audio/mp3" src={link} />
                </audio>}

            </div> */}
        </div>
    );
}
export default AudioRecorder;
export { AudioRecorder };